import { render, staticRenderFns } from "./newGoOnline.vue?vue&type=template&id=266a2134&scoped=true&"
import script from "./newGoOnline.vue?vue&type=script&lang=ts&"
export * from "./newGoOnline.vue?vue&type=script&lang=ts&"
import style0 from "./newGoOnline.vue?vue&type=style&index=0&id=266a2134&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a2134",
  null
  
)

export default component.exports